import { Box, Grid, Typography } from '@mui/material'
import { Container } from '@mui/system'
import React from 'react'
import { Button } from '@mui/material'
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import ImageID002 from '../../../file/Group872.png'
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F7F7F9',
    ...theme.typography.body2,
    /*  padding: theme.spacing(1),  */
    color: theme.palette.text.secondary,
    boxShadow: 'none',
    minHeight: '100%',
    borderRadius: 20,
    position: 'relative'
}));
export default function BoxDialogID002() {
    return (
        <Box>
            <Container maxWidth="md" sx={{ marginTop: 7, padding: 0 }}>
                <Box sx={{ padding: 0 }}>
                    <Typography variant="h3" component="h3" sx={{ textTransform: 'uppercase', fontWeight: 600, opacity: 0.8 }} className=" divide-y ">
                        RSA Encryption Program
                    </Typography>
                    <Box sx={{ flexGrow: 1, marginTop: 5 }}>
                        <Grid container spacing={{ xs: 2, md: 2.5 }} columns={{ xs: 2, sm: 12, md: 12 }}>
                            <Grid item xs={3}>
                                <Box >
                                    <Typography variant="h7" component="h7" sx={{ textTransform: 'uppercase', fontWeight: 600, opacity: 0.5 }}>
                                        VAI TRÒ CỦA TÔI
                                    </Typography>
                                    <Typography sx={{ paddingTop: 0.5, opacity: 0.9 }}>
                                        Web Developer
                                    </Typography>
                                </Box>
                                <Box sx={{ marginTop: 2 }}>
                                    <Typography variant="h7" component="h7" sx={{ textTransform: 'uppercase', fontWeight: 600, opacity: 0.5 }}>
                                        Trách nhiệm
                                    </Typography>
                                    <Typography sx={{ paddingTop: 0.5, opacity: 0.9 }}>
                                        <ul >
                                            <li> Build Front-end</li>
                                        </ul>
                                    </Typography>
                                </Box>
                                <Box sx={{ marginTop: 2 }}>
                                    <Typography variant="h7" component="h7" sx={{ textTransform: 'uppercase', fontWeight: 600, opacity: 0.5 }}>
                                        MỐC THỜI GIAN
                                    </Typography>
                                    <Typography sx={{ paddingTop: 0.5 , opacity: 0.9}}>
                                        Tháng 7 năm 2022
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={9}>
                                <Box>
                                    <Typography variant="h7" component="h7" sx={{ textTransform: 'uppercase', fontWeight: 600, opacity: 0.5 }}>
                                        MÔ TẢ
                                    </Typography>
                                    <Typography sx={{ paddingTop: 0.5 , opacity: 0.9}}>
                                        Một chương trình nhỏ mô tả thuật toán mã hóa RSA, cho phép người dùng giải mã và mã hóa tạo ra các khóa công khai và riêng tư. Đối với bài tập môn An toàn thông tin của tôi.
                                    </Typography>
                                </Box>
                                <Box sx={{ marginTop: 4 }}>
                                    <a href="https://hoangvantuan123.github.io/RSA-Encryption-Program/">

                                        <Button variant="outlined" sx={{
                                            width: '50%', borderRadius: 5, border: 2, borderColor: '#D3D3D3', fontWeight: 'bold', color: '#000000', opacity: 0.8, ':hover': {
                                                bgcolor: '#B6CAE0',
                                                color: '#FFFFFF',
                                                borderColor: '#B6CAE0'
                                            },
                                        }} >
                                            Website

                                        </Button>
                                    </a>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Container>
            <Container maxWidth="xl" sx={{ marginTop: 7, padding: 0 }}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={{ xs: 2, md: 2.5 }} columns={{ xs: 2, sm: 12, md: 12 }}>
                        <Grid item xs={12} >
                            <Item sx={{
                                padding: 3, cursor: 'pointer'
                            }}>
                                <img src={ImageID002} alt="" className=' rounded-lg' />
                            </Item>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Box>
    )
}
